import axios from 'axios';
import { create } from 'apisauce';
import APPCONFIG from '../config/apiConfig';
import store from '../redux/store/store';
import { logout } from '../redux/features/authSlice';


const axiosApiInstance = axios.create({ baseURL: APPCONFIG.endPoint });

// Request interceptor for API calls
axiosApiInstance.interceptors.request.use(
  async (config) => {
    const access_token = localStorage.getItem('accessToken');
    if (access_token) {
      config.headers = {
        Authorization: `Bearer ${access_token}`,
        Accept: "application/json",
      };
    }
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

// Response interceptor for API calls
axiosApiInstance.interceptors.response.use(
  async (response) => {
    return response;
  }, async (error) => {
    const originalRequest = error.config;
    if ((error?.response?.status === 401 || error?.response?.status === 403) && !(originalRequest?._retry)) {
      originalRequest._retry = true;
      let access_token = "";
      const deviceId = 'browser';
      const refreshToken = localStorage.getItem('refreshToken');
      try {
        const response = await appapi
          .get(
            `auth/access_token?grant_type=refresh_token&refresh_token=${refreshToken}&device_id=${deviceId}`
          );
        if (response && response.ok) {
          const data = response.data;
          access_token = data.accessToken;
          localStorage.setItem('accessToken', access_token);
          localStorage.setItem('refreshToken', data.refreshToken);
          axios.defaults.headers["Authorization"] = `Bearer ${access_token}`;
          originalRequest.headers["Authorization"] = `Bearer ${access_token}`;
          return axios.request(originalRequest);
          // return axiosApiInstance(originalRequest);
        } else {
          // return Promise.reject(response.originalError)
          store.dispatch(logout());
        }
      } catch (e) {
        return Promise.reject(error);
      }
    }
    return Promise.reject(error);
  }
);

export const appapi = create({ axiosInstance: axiosApiInstance });

export default appapi;
